import React from 'react';
import { Logo } from '../shared/simple/Logo';
import { RouterLink } from '../shared/simple/RouterLink';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { routes } from '../../constants/routes';
import { logoBgAppOrigin, appsOrigin } from '../../constants/appOrigin';
import wisenrollLogo from '../../assets/images/login/wisenrolIcon.png'

// Define element styles for the component
const LinkStyled = styled(RouterLink)`
  height: 100px;
  max-width: 350px;
  margin: 30px !important;
`;

/**
 * LinkLogo component
 * @component
 * @returns
 */
export const LinkLogo = ({
  className = ''
}) => {
  const { infoProductRequest, selectedProduct } = useSelector(state => state.user);
  const fallbackOrigin = logoBgAppOrigin.default; 
  const preferredImg = infoProductRequest 
    ? (infoProductRequest?.image_main || fallbackOrigin)
    : (selectedProduct?.image_main || fallbackOrigin);

  const [defaultImg, setDefaultImg] = React.useState(preferredImg) // ? Img to be used only if there is an error fetching images

  React.useEffect(() => {
    setDefaultImg(infoProductRequest 
      ? (infoProductRequest?.image_main || fallbackOrigin)
      : (selectedProduct?.image_main || fallbackOrigin))
  }, [infoProductRequest, selectedProduct])

  const onError = () => {
    setDefaultImg(wisenrollLogo)
  }

  return (
    <RouterLink
      className={`p-0 col-12 link-logo ${className}`}
      to={routes.login(appsOrigin.credinomina)}
    >
      <Logo
        onError={() => {
          console.log('ERROR ON THE IMAGE LOADING')
          onError()
        }}
        className="d-none d-md-block"
        src={ defaultImg }
        name={`img_${infoProductRequest ? infoProductRequest?.application?.unique_name : !selectedProduct?.application ? "wisenroll" : selectedProduct.application?.unique_name}`}
      />
    </RouterLink>
  );
};